import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { N300 } from '@atlaskit/theme/colors';
import { themed } from '@atlaskit/theme/components';
var ThemeColor = themed({ light: N300, dark: N300 });
var BreadcrumbsContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  display: flex;\n  flex-wrap: wrap;\n"], ["\n  color: ", ";\n  display: flex;\n  flex-wrap: wrap;\n"])), ThemeColor);
BreadcrumbsContainer.displayName = 'BreadcrumbsContainer';
export default BreadcrumbsContainer;
var templateObject_1;
//# sourceMappingURL=BreadcrumbsContainer.js.map